import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LayoutModule } from '../layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { PopulationListComponent } from './population-list/population-list.component';
import { PopulationSidebarComponent } from './population-sidebar/population-sidebar.component';
import { PopulationComponent } from './population.component';
import { PopulationQueryResolve } from './population.resolve';

@NgModule({
  imports: [CommonModule, SharedModule, LayoutModule],
  declarations: [PopulationComponent, PopulationSidebarComponent, PopulationListComponent],
  providers: [PopulationQueryResolve]
})
export class PopulationModule {}
